import createReactClass from 'create-react-class';
import BaseMixin from './BaseMixin';

const NotTerminal = createReactClass({
  displayName: 'NotTerminal',
  mixins: [BaseMixin],

  render: function() {
    return (
      this.renderTerminalName("not")
    );
  }
});

export default NotTerminal;
